import NewsBody from 'components/Website/Items/ItemBody';
import NewsContainer from 'components/Website/Items/ItemContainer';
import NewsSmallTitle from 'components/Website/Items/ItemSmallTitle';
import PublishDate from 'components/Website/Items/PublishDate';
import ReadMore from 'components/Website/Items/ReadMore';
import Flex from 'components/Flex';
import { ReactComponent as KeepIcon } from 'icons/pinned.svg';
import truncate from 'lodash.truncate';
import styled from 'styled-components';
import React, { FunctionComponent, useMemo } from 'react';

export interface INewsItem {
  title: string;
  body: string;
  publishDate: Date;
  link: string;
  is_pin: boolean;
}

const NewsPreviewItem: FunctionComponent<INewsItem> = ({
  title,
  body,
  publishDate,
  link,
  is_pin,
}) => {
  const bodyLength = 250;
  const truncatedBody = useMemo(
    () =>
      truncate(body, {
        length: bodyLength,
        separator: /,? +/,
      }),
    [body]
  );

  return (
    <NewsContainer>
      <PublishDate date={publishDate} />
      <NewsSmallTitle>
        <Flex alignItems="center">
          {is_pin && <KeepIconStyled width={18} height={18} className="pr6" />}
          {title}
        </Flex>
      </NewsSmallTitle>
      <NewsBody dangerouslySetInnerHTML={{ __html: truncatedBody }} />
      <ReadMore to={link}>Read more</ReadMore>
    </NewsContainer>
  );
};

export default NewsPreviewItem;

const KeepIconStyled = styled(KeepIcon)`
  path {
    fill: ${(props) => props.theme.colors.lightenGrey};
  }
`;
